<template>
  <div class="forget-password-form">
    <el-form
      ref="forgetform"
      :rules="forgetFormRule"
      :model="forgetForm"
      :hide-required-asterisk="true"
      label-width="0"
      class="login-form"
    >
      <el-form-item prop="userName">
        <el-input
          v-model="forgetForm.userName"
          placeholder="请输入账号"
          class="username-input"
        >
          <div slot="prefix">
            <div class="username-input-prefix">
              <div class="form-icon">
                <i class="el-icon-user-solid"></i>
              </div>
              &nbsp;+86
              <!-- <el-select v-model="areaCode" placeholder="请选择">
                <el-option-group
                  v-for="group in areaCodeList"
                  :key="group.code"
                  :label="group.zh"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.en"
                    :label="`+${item.code}`"
                    :value="item.code"
                  >
                    <span style="float: left">{{ item.zh }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px"
                      >+{{ item.code }}</span
                    >
                  </el-option>
                </el-option-group>
              </el-select> -->
            </div>
          </div>
        </el-input>
      </el-form-item>
      <div class="image-captcha-code">
        <el-form-item prop="imageCaptchaCode">
          <el-input
            v-model="forgetForm.imageCaptchaCode"
            class="vcode-input"
            placeholder="请输入图形验证码"
          >
            <!-- <template slot="append">
            <img @click="findImageCaptcha" :src="imageCaptchaUrl" alt />
          </template> -->
          </el-input>
        </el-form-item>

        <img @click="findImageCaptcha" :src="imageCaptchaUrl" alt />
      </div>
      <el-form-item prop="captcha">
        <el-input v-model="forgetForm.captcha" placeholder="请输入短信验证码">
          <div slot="prefix">
            <div class="form-icon">
              <i class="el-icon-success"></i>
            </div>
          </div>
          <template slot="append">
            <el-link
              :underline="false"
              type="primary"
              @click="timer ? '' : findPassCaptch()"
              >{{ timer ? `${timeCount}s后重发` : "获取验证码" }}</el-link
            >
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="passWord">
        <el-input
          :type="isShowPassword ? 'text' : 'password'"
          v-model="forgetForm.passWord"
          placeholder="请设置新密码"
        >
          <div slot="append">
            <div class="form-icon">
              <i
                class="iconfont"
                :class="isShowPassword ? 'icon002yincang' : 'iconyincang'"
                @click="isShowPassword = !isShowPassword"
              ></i>
            </div>
          </div>
          <div slot="prefix">
            <div class="form-icon">
              <i class="el-icon-lock"></i>
            </div>
          </div>
        </el-input>
      </el-form-item>
    </el-form>
    <el-button class="login-btn" type="primary" @click="findPassWord"
      >找回并登录</el-button
    >
    <div class="next-btn">
      <el-link :underline="false" type="info" @click="$emit('changeTab')"
        >已有账号，立即登录</el-link
      >
    </div>
  </div>
</template>

<script>
import areaCodeList from "@/assets/js/code.json";
import { findImageCaptcha, findPassCaptch, findPassWord } from "@/api";
import { mapState } from "vuex";
export default {
  data() {
    return {
      forgetForm: {
        userName: "",
        passWord: "",
        imageCaptchaCode: "",
        imageCaptchaToken: "",
        captcha: "",
      },
      forgetFormRule: {
        userName: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        passWord: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        imageCaptchaCode: [
          {
            required: true,
            message: "请输入图形验证码",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
      },
      areaCodeList: areaCodeList,
      areaCode: 86,
      isShowPassword: false,
      imageCaptchaUrl: "",
      timer: null,
      timeCount: 60,
    };
  },
  computed: {
    ...mapState({
      projectConfig: (state) => state.projectConfig,
    }),
  },
  mounted() {
    this.findImageCaptcha();
  },
  methods: {
    findImageCaptcha() {
      findImageCaptcha().then((res) => {
        if (res.code == 1) {
          this.imageCaptchaUrl = res.data.imageCaptchaUrl;
          this.forgetForm.imageCaptchaToken = res.data.imageCaptchaToken;
        }
      });
    },
    findPassCaptch() {
      if (!/^1[3456789]\d{9}$/.test(this.forgetForm.userName)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!this.forgetForm.imageCaptchaCode) {
        this.$message.warning("请输入图形验证码");
        return;
      }
      this.timeCount = 60;
      findPassCaptch({
        userName: this.forgetForm.userName,
        imageCaptchaToken: this.forgetForm.imageCaptchaToken,
        imageCaptchaCode: this.forgetForm.imageCaptchaCode,
      }).then((res) => {
        if (res.code == 1) {
          this.timer = setInterval(() => {
            this.timeCount--;
            if (this.timeCount == 0) {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
          this.findImageCaptcha();
        }
      });
    },
    findPassWord() {
      this.$refs.forgetform.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.forgetForm));
          findPassWord(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "修改成功",
                type: "success",
                duration: 2000,
              });
              setTimeout(() => {
                this.$router.push({
                  path: "/login",
                });
              }, 1000);
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.forget-password-form {
  width: 100%;
}
</style>

<style lang="less"></style>
